<template>
  <div v-if="initDone">
    <template v-if="$store.state.device.isPC">
      <HeaderPC />
    </template>
    <template v-else>
      <HeaderWAP />
    </template>
    <router-view />
    <template v-if="$store.state.device.isPC">
      <FooterPC />
      <SliderBar />
    </template>
    <template v-else>
      <FooterWAP />
    </template>
  </div>
  <div v-else class="loading-screen"></div>
</template>

<script>
import store from '@/store'
import HeaderPC from "@/components/pc/HeaderPC";
import HeaderWAP from "@/components/wap/HeaderWAP";
import FooterPC from "@/components/pc/FooterPC";
import FooterWAP from "@/components/wap/FooterWAP";
import SliderBar from './components/common/SliderBar.vue';
export default {
  components: {
    HeaderPC,
    HeaderWAP,
    FooterPC,
    FooterWAP,
    SliderBar
  },
  data: () => ({ initDone: false }),
  store,
  created() {
    this.checkGlobalUserId();
    document.title = 'Dell Technologies';
  },
  mounted() {
    this.$nextTick(() => {
      this.initDone = true
    })
  },
  methods: {
    checkGlobalUserId() {
      const globalUserId = this.$cookies.get('globalUserId');
      if (!globalUserId) {
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
        uuid = uuid.replace(/-/g, '');
        this.$cookies.set('globalUserId', uuid, { expires: 365, path: '/', domain: window.location.host });
      }
      
      // 设置GIO用户标识
      if (window.gio && typeof window.gio === 'function') {
        try {
          const userId = this.$cookies.get('globalUserId');
          if (userId) {
            window.gio('setUserId', userId);
          }
        } catch (error) {
          console.error('GIO setUserId error:', error);
        }
      }
    }
  }
}
</script>

<style lang="scss">
body{
  margin: 0;
}
</style>
